import styled from 'styled-components';

export const FilterComponentWrapper = styled.div`
    background: #ffff;
    margin: 5px 16px;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;

export const FilterComponentHeaderFooter = styled.div`
    background: #ffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 28px;
    padding-right: 19px;
    padding-top: 18px;
    padding-bottom: 20px;
    border-radius: 6px;
    align-items: center;
    cursor: pointer;
`;
export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld demi;
    color: ${(props) => props.color};
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;
export const DefaultIndicator = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 10px;
    color: #e5047e;
    margin-left: 10px;
    border: 1px solid #e5047e;
    border-radius: 3px;
    width: 47px;
    height: 18px;
    display: flex;
    justify-content: center;
`;

export const OrderStatusGroup = styled.div`
    font-family: AvenirNextWorld Demi;
    letter-spacing: 0px;
    color: #9d9d9d;
    text-transform: uppercase;
    opacity: 1;
    display: flex;
    width: 100%;
    font-size: 12px;
    justify-content: left;
    align-items: center;
    padding-left: 28px;
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    margin-top: 0;
`;
